module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step1_Image2.ac231be1.jpg";